import { Controller } from "@hotwired/stimulus";

const MAX_ROWS = 30;

export default class TitleTemplatesAdminController extends Controller {
  static targets = ["list", "row"];
  static values = {
    placeholderName: String,
    ariaName: String,
    placeholderBody: String,
    ariaBody: String,
    ariaRemove: String,
  };

  addRow() {
    if (this.rowTargets.length >= MAX_ROWS) return;

    const idx = this.rowTargets.length;
    const row = document.createElement("div");
    row.className = "flex items-center gap-2 mb-2";
    row.dataset.titleTemplatesAdminTarget = "row";
    row.innerHTML = `
      <input type="text" name="title_templates[${idx}][name]" value=""
             class="input input-bordered input-sm w-36 shrink-0">
      <input type="text" name="title_templates[${idx}][template]" value=""
             class="input input-bordered input-sm flex-1">
      <button type="button" class="btn btn-ghost btn-sm btn-square text-error/70 hover:text-error"
              data-action="click->title-templates-admin#removeRow">
        <i class="fa-solid fa-trash-can"></i>
      </button>
    `;
    const [nameInput, templateInput] = row.querySelectorAll("input");
    nameInput.placeholder = this.placeholderNameValue;
    nameInput.setAttribute("aria-label", this.ariaNameValue);
    templateInput.placeholder = this.placeholderBodyValue;
    templateInput.setAttribute("aria-label", this.ariaBodyValue);
    row.querySelector("button").setAttribute("aria-label", this.ariaRemoveValue);
    this.listTarget.appendChild(row);
    nameInput.focus();
    this.#reindex();
  }

  removeRow(event) {
    event.currentTarget.closest("[data-title-templates-admin-target='row']")?.remove();
    this.#reindex();
    // Removing a row is a real data change, but it fires no input/change event on its own —
    // nudge the enclosing autosave controller (see StreamCommand-4ibi) to pick it up.
    this.element.dispatchEvent(new Event("change", { bubbles: true }));
  }

  #reindex() {
    this.rowTargets.forEach((row, idx) => {
      row.querySelectorAll("input[name]").forEach((input) => {
        input.name = input.name.replace(/\[\d+\]/, `[${idx}]`);
      });
    });
  }
}
